import axios from "axios";

export default {
  registro: function(email, hashContrasena, apellido, nombre, telefono, dni, ip, apiToken, handler) {
    axios
      .post(`${process.env.VUE_APP_SERVER_URL}/api/Usuarios/Registro`, {
        email,
        hashContrasena,
        apellido,
        nombre,
        telefono,
        dni,
        ip,
        apiToken
      })
      .then(handler);
  },
  login: function(nombreUsuario, hashContrasena, ip, apiToken, version, handle) {
    axios
      .post(`${process.env.VUE_APP_SERVER_URL}/api/Usuarios/Login`, {
        nombreUsuario,
        hashContrasena,
        ip,
        apiToken,
        version
      })
      .then(handle);
  },
  cambiarContrasena: function(hashContrasenaAnterior, hashContrasenaNueva, token, handle) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Usuarios/CambiarContrasena`,
        {
          hashContrasenaAnterior,
          hashContrasenaNueva
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handle);
  },
  enviarMailRecuperacionContrasena: function(email, apiToken, handle) {
    axios
      .post(`${process.env.VUE_APP_SERVER_URL}/api/Usuarios/OlvideMiContrasena`, {
        email,
        apiToken
      })
      .then(handle);
  },
  verificarCodigoRecuperacionContrasena: function(email, codigo, apiToken, handle) {
    axios
      .post(`${process.env.VUE_APP_SERVER_URL}/api/Usuarios/VerificarCodigoRecuperacionContrasena`, {
        email,
        codigo,
        apiToken
      })
      .then(handle);
  },
  cambiarContrasenaOlvidada: function(email, codigo, hashContrasena, apiToken, handle) {
    axios
      .post(`${process.env.VUE_APP_SERVER_URL}/api/Usuarios/CambiarContrasenaOlvidada`, {
        email,
        codigo,
        hashContrasena,
        apiToken
      })
      .then(handle);
  },
  actualizarDatosPersonales: function(email, apellido, nombre, dni, telefono, fotoDni, token, handle) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Usuarios/ActualizarDatosPersonales`,
        {
          email,
          apellido,
          nombre,
          dni,
          telefono,
          fotoDni
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handle);
  },
  obtenerDatosPersonalesPorToken: function(tokenUsuario, handle) {
    axios
      .post(`${process.env.VUE_APP_SERVER_URL}/api/Usuarios/ObtenerDatosPersonalesPorToken`, {
        token: tokenUsuario
      })
      .then(handle);
  },
  obtenerFotoDni: function(token, handle) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Usuarios/ObtenerFotoDni`,
        {},
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handle);
  },
  actualizarDatosPersonalesExterno: function(tokenUsuario, email, apellido, nombre, dni, telefono, fotoDni, handle) {
    axios
      .post(`${process.env.VUE_APP_SERVER_URL}/api/Usuarios/ActualizarDatosPersonalesExterno`, {
        tokenUsuario,
        email,
        apellido,
        nombre,
        dni,
        telefono,
        fotoDni
      })
      .then(handle);
  }
};
